import { render, staticRenderFns } from "./DeskCreate.vue?vue&type=template&id=9293464e&scoped=true"
import script from "./DeskCreate.vue?vue&type=script&lang=js"
export * from "./DeskCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9293464e",
  null
  
)

export default component.exports